import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Button from 'components/button/Button';
import messages from 'messages';
import { StoreContext } from 'index';

const ConfirmMutationButton = ({
  children,
  confirmType,
  confirmTitle,
  confirmMessage,
  messageValues,
  confirmAcceptLabel = messages.modalConfirmRemoveAcceptButton,
  confirmCancelLabel = messages.modalConfirmRemoveCancelButton,
  mutation,
  variables,
  refetchQueries,
  onQueryUpdated,
  update,
  onError,
  onClick,
  disabled,
  ...props
}) => {
  const { uiState } = useContext(StoreContext);
  const intl = useIntl();

  return (
    <Button
      {...props}
      disabled={disabled}
      onClick={e => {
        e.preventDefault();
        if (onClick) onClick();
        // @ts-ignore
        uiState.showModal({
          title: confirmTitle
            ? intl.formatMessage(confirmTitle, messageValues)
            : '',
          message: confirmMessage ? confirmMessage : '',
          values: messageValues ? messageValues : '',
          okLabel: intl.formatMessage(confirmAcceptLabel),
          dismissLabel: intl.formatMessage(confirmCancelLabel),
          okHandler: () => {
            uiState.increasePendingRequest();
          },
          type: confirmType,
          mutationData: {
            mutation,
            variables,
            refetchQueries,
            update: (cache, data) => {
              uiState.decreasePendingRequest();
              if (update) update(cache, data);
            },
            onError
          }
        });
      }}
      dataQa={props.dataQa}
    >
      {children}
    </Button>
  );
};

export default ConfirmMutationButton;
